module.exports = __webpack_public_path__ + "img/0Q3A4053_L_BlackMatted.22da0ef0.jpg";